var _g, _g2, _g3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgThreeCircleinline = function SvgThreeCircleinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 577,
    height: 694,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#three-circle_inline_svg__a)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 153.5,
    cy: 283.5,
    r: 53.5,
    fill: "url(#three-circle_inline_svg__b)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#three-circle_inline_svg__c)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 342,
    cy: 459,
    r: 135,
    fill: "url(#three-circle_inline_svg__d)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#three-circle_inline_svg__e)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 299.5,
    cy: 153.5,
    r: 53.5,
    fill: "url(#three-circle_inline_svg__f)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "three-circle_inline_svg__b",
    x1: 98.997,
    x2: 207.017,
    y1: 278.345,
    y2: 279.046,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#255DDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.495,
    stopColor: "#00A98F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "three-circle_inline_svg__d",
    x1: 204.469,
    x2: 477.043,
    y1: 445.993,
    y2: 447.761,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#255DDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.495,
    stopColor: "#00A98F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "three-circle_inline_svg__f",
    x1: 244.997,
    x2: 353.017,
    y1: 148.345,
    y2: 149.046,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#255DDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.495,
    stopColor: "#00A98F"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "three-circle_inline_svg__a",
    width: 307,
    height: 307,
    x: 0,
    y: 130,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_1292_30",
    stdDeviation: 50
  })), /*#__PURE__*/React.createElement("filter", {
    id: "three-circle_inline_svg__c",
    width: 470,
    height: 470,
    x: 107,
    y: 224,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_1292_30",
    stdDeviation: 50
  })), /*#__PURE__*/React.createElement("filter", {
    id: "three-circle_inline_svg__e",
    width: 307,
    height: 307,
    x: 146,
    y: 0,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_1292_30",
    stdDeviation: 50
  })))));
};
export default SvgThreeCircleinline;